import {
  CARE_PLAN_SERVICE_KEY,
  CWF_DOCUMENT_TYPE_NAMES,
  CwfActiveDocument,
  CwfDocumentType,
  ServicesInfo,
  Sku,
} from '@/api';

import { CWF_DOCS_TYPES_MAP } from '../constant';

interface DetermineDocumentPlaceholdersArgs {
  documents: CwfActiveDocument[];
  servicesInfo: ServicesInfo[];
  sku?: Sku;
  types: CwfDocumentType[];
}

export function determineDocumentPlaceholders({
  documents,
  servicesInfo,
  sku,
  types,
}: DetermineDocumentPlaceholdersArgs): {
  advancedHeartPlaceholder: boolean;
  advancedNeuroPlaceholder: boolean;
  bodyCompPlaceholder: boolean;
} {
  if (!sku) {
    return {
      advancedHeartPlaceholder: false,
      advancedNeuroPlaceholder: false,
      bodyCompPlaceholder: false,
    };
  }

  const hasAdvancedNeuro = documents.some(
    ({ typeId }) =>
      types.find(({ uuid }) => uuid === typeId)?.name === CWF_DOCUMENT_TYPE_NAMES.ADVANCE_NEURO,
  );

  const hasAdvancedHeart = documents.some(
    ({ typeId }) =>
      types.find(({ uuid }) => uuid === typeId)?.name === CWF_DOCUMENT_TYPE_NAMES.ADVANCE_HEART,
  );

  const hasBodyComposition = documents.some(
    ({ typeId }) =>
      types.find(({ uuid }) => uuid === typeId)?.name === CWF_DOCUMENT_TYPE_NAMES.BODY_COMPOSITION,
  );

  return {
    '100': {
      advancedHeartPlaceholder: false,
      advancedNeuroPlaceholder: false,
      bodyCompPlaceholder: false,
    },
    '200': {
      advancedHeartPlaceholder: false,
      advancedNeuroPlaceholder: false,
      bodyCompPlaceholder: false,
    },
    '300': {
      advancedHeartPlaceholder: false,
      advancedNeuroPlaceholder: false,
      bodyCompPlaceholder: false,
    },
    '350': {
      advancedHeartPlaceholder: false,
      advancedNeuroPlaceholder: false,
      bodyCompPlaceholder: false,
    },
    '370': {
      advancedHeartPlaceholder: false,
      advancedNeuroPlaceholder:
        !hasAdvancedNeuro &&
        CWF_DOCS_TYPES_MAP[sku].includes(CWF_DOCUMENT_TYPE_NAMES.ADVANCE_NEURO),
      bodyCompPlaceholder:
        !hasBodyComposition &&
        CWF_DOCS_TYPES_MAP[sku].includes(CWF_DOCUMENT_TYPE_NAMES.BODY_COMPOSITION),
    },
    '400': {
      advancedHeartPlaceholder: false,
      advancedNeuroPlaceholder: false,
      bodyCompPlaceholder: false,
    },
    '900': {
      advancedHeartPlaceholder:
        !hasAdvancedHeart &&
        servicesInfo.some(
          (service) => service.code === CARE_PLAN_SERVICE_KEY.IMAGING_BASE_ADVANCE_HEART,
        ),
      advancedNeuroPlaceholder:
        !hasAdvancedNeuro &&
        servicesInfo.some(
          (service) => service.code === CARE_PLAN_SERVICE_KEY.IMAGING_BASE_ADVANCE_NEURO,
        ),
      bodyCompPlaceholder:
        !hasBodyComposition &&
        servicesInfo.some(
          (service) => service.code === CARE_PLAN_SERVICE_KEY.IMAGING_BASE_BODY_COMPOSITION,
        ),
    },
  }[sku];
}
